import { API } from '../../../core/http/api'

const controlStatusFnct = (res, error) => {
  if (res.status === 401 && !(process.env.TEST_API || process.env.TEST)) {
    window.localStorage.clear()
    window.location.reload()
  } else {
    throw new Error(error)
  }
}

export async function getBoxesLabels () {
  const res = await API.get('labels?limit=50')
  if (res.status !== 200) controlStatusFnct(res, 'Unexpected status code for GET /labels')
  return res.data
}

export async function createBoxLabel (labelName) {
  const res = await API.post('labels', { name: labelName })
  if (res.status !== 201) this.controlStatusFnct(res, 'Unexpected status code for POST /labels')
  return res
}

export async function changeBoxLabelName ({ labelId, labelName }) {
  const res = await API.put(`labels/${labelId}`, { name: labelName })
  if (res.status !== 200) this.controlStatusFnct(res, `Unexpected status code for PUT /labels/${labelId}`)
  return res
}
export async function changeBoxLabelIndex ({ labelId, index }) {
  const res = await API.put(`labels/change-order/${labelId}`, { targetIndex: index })
  if (res.status !== 200) this.controlStatusFnct(res, `Unexpected status code for PUT /labels/${labelId}`)
  return res
}

export async function deleteBoxLabel (labelId) {
  const res = await API.delete(`labels/${labelId}`)
  if (res.status !== 200) this.controlStatusFnct(res, 'Unexpected status code for DELETE /labels')
  return res
}

export async function setBoxLabelVisibility (labelId, hideLabelInMainFeed) {
  const res = await API.put(`labels/${labelId}`, { shownInFeed: !hideLabelInMainFeed })
  if (res.status !== 200) this.controlStatusFnct(res, `Unexpected status code for PUT /labels/${labelId}`)
  return res
}
